// extracted by mini-css-extract-plugin
export default {"primaryButton":"primaryButton__3MqWp","backButton":"backButton__UfmJ5"};
    if(module.hot) {
      // 1778491671627
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  